module.exports = __webpack_public_path__ + "img/tree.527a1748.svg";